<template>
  <div class="container fluid">
    <div class="mb-2">
      <v-layout row wrap class="ma-0 pa-0">
        <v-flex xs12 sm6>
          <v-btn
            depressed
            :outline="channelFilter != 'all'"
            :color="channelFilter == 'all' ? 'primary' : 'grey'"
            @click="channelFilter = 'all'"
            class="ma-0 mr-1 mb-1"
            >{{ $t('All') }}</v-btn
          >
          <v-btn
            depressed
            :outline="channelFilter != 'facebook'"
            :color="channelFilter == 'facebook' ? 'primary' : 'grey'"
            @click="channelFilter = 'facebook'"
            class="ma-0 mr-1 mb-1"
          >
            <em class="fab fa-facebook-square mr-1" />
            {{ $t('Facebook') }}
          </v-btn>
          <v-btn
            depressed
            :outline="channelFilter != 'line'"
            :color="channelFilter == 'line' ? 'primary' : 'grey'"
            @click="channelFilter = 'line'"
            class="ma-0 mr-1 mb-1"
          >
            <em class="fab fa-line mr-1" />
            {{ $t('Line') }}
          </v-btn>
        </v-flex>
        <v-flex xs12 sm6 class="text-xs-right">
          <v-btn @click="exportxlsx" color="grey" outline>
            <em class="fas fa-file-export" />
            &nbsp;Export&nbsp;
          </v-btn>
        </v-flex>
      </v-layout>
    </div>
    <div class="mb-2">
      <date-filter
        @changeDate="onChangeDate"
        :defaultFilter="'last_7_days'"
        v-model="selectedDate"
      ></date-filter>
    </div>

    <!-- Graph -->
    <div>
      <div class="mt-5">
        <purchase-by-date
          :selectedDate="selectedDate"
          @dataPurchaseDate="setDataPurchaseDate"
        ></purchase-by-date>
      </div>
      <div class="mt-5">
        <purchase-by-time
          :selectedDate="selectedDate"
          @dataPurchaseTime="setDataPurchaseTime"
        ></purchase-by-time>
      </div>
      <div class="mt-5">
        <purchase-by-shop
          :selectedDate="selectedDate"
          @dataPurchaseShop="setDataPurchaseShop"
        ></purchase-by-shop>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import moment from 'moment'
import VueApexCharts from 'vue-apexcharts'
import exportxlsx from '@/components/elements/exportxlsx.vue'
import DateFilter from '@/components/view/dashboard/DateFilter.vue'
import DatePickerWithoutButton from '@/components/elements/DatePickerWithoutButton.vue'
import PurchaseByDate from './PurchaseByDate.vue'
import PurchaseByTime from './PurchaseByTime.vue'
import PurchaseByShop from './PurchaseByShop.vue'
import XLSX from 'xlsx'

export default {
  components: {
    exportxlsx,
    DateFilter,
    DatePickerWithoutButton,
    apexchart: VueApexCharts,
    PurchaseByTime,
    PurchaseByDate,
    PurchaseByShop
  },
  data() {
    return {
      selectedDate: {
        start: moment().subtract(7, 'days').format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD')
      },
      channelFilter: 'all',
      filter: {
        app: ''
      },

      dataPurchaseDate: '',
      dataPurchaseTime: '',
      dataPurchaseShop: ''
    }
  },
  mounted() {
    this.getPurchaseByShop()
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  methods: {
    exportxlsx() {
      let sheet1 = []
      let sheet2 = []
      let sheet3 = []

      $.each(this.dataPurchaseDate, function (index, val) {
        sheet1.push({
          วันที่: moment(val['date']).format('DD-MM-YYYY'),
          จำนวนคำสั่งซื้อ: parseInt(val['total'])
        })
      })

      $.each(this.dataPurchaseTime, function (index, val) {
        var time = index.split('_')[1] + ':00'
        sheet2.push({
          เวลา: time,
          จำนวนคำสั่งซื้อ: parseInt(val)
        })
      })

      var count = 0
      $.each(this.dataPurchaseShop, function (index, val) {
        count += parseInt(val.total)
      })

      this.dataPurchaseShop.map((el) => {
        var percent = parseFloat((el.total * 100) / count).toFixed(2)

        sheet3.push({
          สาขา: el.shop_via,
          จำนวนคำสั่งซื้อ: el.total,
          '%': percent + '%'
        })
      })

      const wb = XLSX.utils.book_new()
      const dataWS1 = XLSX.utils.json_to_sheet(sheet1)
      const dataWS2 = XLSX.utils.json_to_sheet(sheet2)
      const dataWS3 = XLSX.utils.json_to_sheet(sheet3)
      XLSX.utils.book_append_sheet(wb, dataWS1, 'Purchase by Date')
      XLSX.utils.book_append_sheet(wb, dataWS2, 'Purchase by Time')
      XLSX.utils.book_append_sheet(wb, dataWS3, 'Purchase by Shop')

      XLSX.writeFile(wb, 'Lamy_Overview2_Report' + '.xlsx')
    },

    getPurchaseByShop() {
      return new Promise((resolve) => {
        var vm = this
        var data = {
          pageid: vm.selectedBot.pageid, // required
          start_date: moment(vm.selectedDate.start).format('YYYY-MM-DD'), // YYYY-MM-DD
          end_date: moment(vm.selectedDate.end).format('YYYY-MM-DD') // YYYY-MM-DD
        }
        vm.loading = true
        api.getLamyOverview2PurchaseByShop(data, (err, response) => {
          if (response.responsecode == 200) {
            var chartData = response.data[0]
            // vm.series[0].data = Object.values(chartData);
            vm.loading = false
            resolve(response.data)
          } else {
            console.log(err)
            return
          }
        })
      })
    },
    onChangeDate() {
      this.getPurchaseByShop()
    },
    setDataPurchaseDate(val) {
      this.dataPurchaseDate = val
    },
    setDataPurchaseTime(val) {
      this.dataPurchaseTime = val
    },
    setDataPurchaseShop(val) {
      this.dataPurchaseShop = val
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/lamy/PurchaseBehavior/Overview2.vue